enum Environment {
  Testing = 'testing',
  Production = 'production',
}

export default Environment;
